export const reOrgConversionMeasurementUnitConstants = {
	Create: {
		FAILURE : 'CREATE_REORG_CONVERSION_MEASUREMENT_UNIT_FAILURE',
		REQUEST : 'CREATE_REORG_CONVERSION_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'CREATE_REORG_CONVERSION_MEASUREMENT_UNIT_SUCCESS'
	},
	Delete: {
		FAILURE : 'DELETE_REORG_CONVERSION_MEASUREMENT_UNIT_FAILURE',
		REQUEST : 'DELETE_REORG_CONVERSION_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'DELETE_REORG_CONVERSION_MEASUREMENT_UNIT_SUCCESS'
	},
	DeleteSelected: {
		REQUEST : 'DELETE_SELECTED_REORG_CONVERSION_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'DELETE_SELECTED_REORG_CONVERSION_MEASUREMENT_UNIT_SUCCESS',
		FAILURE : 'DELETE_SELECTED_REORG_CONVERSION_MEASUREMENT_UNIT_FAILURE'
	},
	DeleteByFilter: {
		REQUEST : 'DELETE_BY_FILTER_REORG_CONVERSION_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'DELETE_BY_FILTER_REORG_CONVERSION_MEASUREMENT_UNIT_SUCCESS',
		FAILURE : 'DELETE_BY_FILTER_REORG_CONVERSION_MEASUREMENT_UNIT_FAILURE'
	},
	GetPaged: {
		FAILURE : 'GET_PAGED_REORG_CONVERSION_MEASUREMENT_UNIT_FAILURE',
		REQUEST : 'GET_PAGED_REORG_CONVERSION_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'GET_PAGED_REORG_CONVERSION_MEASUREMENT_UNIT_SUCCESS'
	},
	GetPagedAudit: {
		FAILURE : 'GET_PAGED_AUDIT_REORG_CONVERSION_MEASUREMENT_UNIT_FAILURE',
		REQUEST : 'GET_PAGED_AUDIT_REORG_CONVERSION_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'GET_PAGED_AUDIT_REORG_CONVERSION_MEASUREMENT_UNIT_SUCCESS'
	},
	Restore: {
		FAILURE : 'RESTORE_REORG_CONVERSION_MEASUREMENT_UNIT_FAILURE',
		REQUEST : 'RESTORE_REORG_CONVERSION_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'RESTORE_REORG_CONVERSION_MEASUREMENT_UNIT_SUCCESS'
	},
	Update: {
		FAILURE : 'UPDATE_REORG_CONVERSION_MEASUREMENT_UNIT_FAILURE',
		REQUEST : 'UPDATE_REORG_CONVERSION_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'UPDATE_REORG_CONVERSION_MEASUREMENT_UNIT_SUCCESS'
	},
	GetExampleFile: {
		FAILURE : 'GET_EXAMPLE_FILE_REORG_CONVERSION_MEASUREMENT_UNIT_FAILURE',
		REQUEST : 'GET_EXAMPLE_FILE_REORG_CONVERSION_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'GET_EXAMPLE_FILE_REORG_CONVERSION_MEASUREMENT_UNIT_SUCCESS'
	},
	Upload: {
		FAILURE : 'UPLOAD_FILE_REORG_CONVERSION_MEASUREMENT_UNIT_FAILURE',
		REQUEST : 'UPLOAD_FILE_CONVERSION_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'UPLOAD_FILE_CONVERSION_MEASUREMENT_UNIT_SUCCESS'
	},
	CLEAR: 'CLEAR_REORG_CONVERSION_MEASUREMENT_UNIT'
}